import { Text } from '@chakra-ui/react'
import { Section } from '@/components/layout'
import { SectionLabel } from '@/components/typography'
import { useLocale } from '@/i18n'
import { MISSION_COPY } from './mission.data'

/** Hungarian-only mission band; the English copy has no equivalent. */
export const Mission = () => {
  const { locale } = useLocale()
  if (locale !== 'hu') return null

  return (
    <Section id="method">
      <SectionLabel mb="32px">{MISSION_COPY.sectionLabel}</SectionLabel>
      <Text
        as="blockquote"
        fontFamily="heading"
        fontWeight="800"
        fontSize="clamp(24px, 2.3vw, 36px)"
        lineHeight="1.2"
        letterSpacing="-0.025em"
        maxW="34ch"
      >
        {MISSION_COPY.quote}
      </Text>
    </Section>
  )
}
